import appGlobalScript from '/home/runner/work/platform/platform/website/extensions/nxstaedtler/Resources/Private/App/source/script/global/staedtler-global.ts';
export const globalScripts = appGlobalScript;
export const globalStyles = "";
